import Pedido from '../../spa/pedidos/Pedidos';

export default {
  path: 'pedido',
  name: 'pedido',
  component: Pedido,
};



// WEBPACK FOOTER //
// ./src/config/router/pedido.js